//@ts-nocheck
"use client";

import { useEffect } from "react";

const GTMBodyNoScript = () => {
    useEffect(() => {
        const noscript = document.createElement("noscript");
        noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NL5W8QL6"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
        // Insert it immediately after <body> starts
        document.body.insertBefore(noscript, document.body.firstChild);

        return () => {
            if (document.body.contains(noscript)) {
                document.body.removeChild(noscript);
            }
        };
    }, []);

    return null;
};

export default GTMBodyNoScript;
